module.exports = __webpack_public_path__ + "static/img/gsq.2ef5f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example/gsq.png
// module id = HBcY
// module chunks = 1